import {courseColors} from "../../../constants/reference.data";
import {bettingTypes, BettingTypesMap} from "features/core/definitions";
import {dateFormat} from "../../../services/misc.functions";
import {getAvailableFOBHippodromes, useAvailableFOBHippodromes, useBulletin} from "features/bulletin/bulletin.store";
import React, {useEffect, useRef, useState} from "react";
import {
    FOBBetslip,
    resolveFobCurrentPick,
    useFobBetslip,
    useFobPendingPicks,
} from "features/betslip/fob.service";
import {NewFobBetslip, NewFobBetslipToggleTab, NewMobileFobBetslipBar} from "./new.fob.betslip";
import paths from "../../../paths";
import {modalServiceSubject} from "services/modal.service";
import {
    asModalHtml,
    fobExcludedHorseNo,
    fobListSelectionBreak,
    fobMoveNotice,
    fobOddsEntry,
    hippodromeHasFobContent,
    isOddsEntrySelectable,
    isRunEligibleForFobBettingType,
    nextFobTypeWithContent,
    runHasFavoriteExcludedMarket,
} from "features/betslip/lib/selection-guard";
import {Link, useLocation, useNavigate} from "react-router-dom";
import redHorse from "../../../assets/img/kirmiziat.png";
import liveIcon from "../../../assets/icons/live-bold.svg";
import goRightIcon from "../../../assets/icons/go-right.svg";
import {isMobile} from "../../../App";
import Draggable from "react-draggable";
import "./fob-betting.css";
import lockIcon from "../../../assets/feather/lock.svg";
import plusIcon from "../../../assets/feather/plus.svg";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import {todayResults} from "../../../store/misc.store";
import jokeyIcon from "../../../assets/img/jokey.png";
import iconDownArrow from "../../../assets/feather/chevron-down.svg";
import iconUpArrow from "../../../assets/feather/chevron-up.svg";
import {getPrettyFormatLastSix} from "features/bulletin/bulletin.service";
import _ from "lodash";

const RaceCountdown = ({hippodrome, run}: any) => {
    const [countdown, setCountdown] = useState<string>("");

    useEffect(() => {
        const updateCountdown = () => {
            const nextRun = run ?? hippodrome.nextRun;

            if (!nextRun?.running_date) {
                setCountdown("--:--");
                return;
            }

            const diff = nextRun.running_date.getTime() - Date.now();

            if (diff <= 0) {
                setCountdown("--:--");
                return;
            }

            const minutes = Math.ceil(diff / 60000);
            setCountdown(`${Math.floor(minutes / 60).toString().padStart(2, "0")}:${(minutes % 60).toString().padStart(2, "0")}`);
        };

        updateCountdown();

        const interval = setInterval(updateCountdown, 15 * 1000);
        return () => clearInterval(interval);
    }, [hippodrome, run]);

    return <div>{countdown}</div>;
};

function findFobBettingType(hippodrome: any, typeId: number): any {
    const wager = hippodrome?.wager_details?.find((w: any) => Number(w.type) === typeId);
    return wager ? bettingTypes.find((bt: any) => bt.id === typeId) ?? null : null;
}

function firstAvailableFobBettingType(hippodrome: any): any {
    const hippodromesToCheck = hippodrome ? [hippodrome] : getAvailableFOBHippodromes();

    for (const _hippodrome of hippodromesToCheck) {
        const wager = _hippodrome?.wager_details?.find((w: any) => (
            BettingTypesMap[Number(w.type)]?.isFob && BettingTypesMap[Number(w.type)]?.isSelectable
        ));
        if (wager) return findFobBettingType(_hippodrome, Number(wager.type));
    }

    return null;
}

export function FOBBetting() {
    const fobHippodromes = useAvailableFOBHippodromes();
    const isBulletinLoaded = Object.keys(useBulletin()).length > 0;
    const location = useLocation();
    const navigate = useNavigate();

    const hippodrome = fobHippodromes.find((_hippodrome: any) => (
        `${_hippodrome.keyword}${_hippodrome._id}`.toLowerCase() === location.pathname.split('/')[2]
    ))

    const linkHippodrome = hippodrome ?? fobHippodromes.find((_hippodrome: any) => _hippodrome.wager_details.length > 0)

    const [pickedBettingType, setPickedBettingType] = useState<any>(null);
    const selectedBettingType = pickedBettingType ?? firstAvailableFobBettingType(hippodrome);
    const [hiddenResultsByHippodrome, setHiddenResultsByHippodrome] = useState<Record<string, boolean>>({});
    const [isDesktopSlipOpen, setIsDesktopSlipOpen] = useState(false);
    const [isMobileSlipOpen, setIsMobileSlipOpen] = useState(false);
    const [liveOnly, setLiveOnly] = useState(false);
    const shownBreakKey = useRef<string | null>(null);

    const liveRunsCount = fobHippodromes.reduce((count: number, h: any) => (
        count + h.runs.filter((r: any) => r.fob_wager_status).length
    ), 0);

    // Sabit ihtimallide bağlam kırılınca MODAL YOK: sepet bağlam-bağımsız olduğu için
    // (çok kartlı/çok koşulu) taşımak hiçbir seçimi gizlemiyor, geçiş bedava. Kullanıcıya
    // yalnız ekranın neden kaydığı bir şeritle söyleniyor; kupondaki geçersiz bacak ayrıca
    // kendi satırında işaretli kalır.
    useEffect(() => {
        // Adreste kart segmenti yoksa kapsam "Hepsi"dir ve hiç kırılmaz. Segment VARSA ama
        // kart listede yoksa `hippodrome` undefined kalır; kırılmayı raporlayabilmek için
        // adresteki anahtar geçiliyor (listede bulunamayacağı için "card" döner).
        const urlCardKey = location.pathname.split("/")[2];
        const brk = fobListSelectionBreak({
            cardId: urlCardKey ? (hippodrome?._id ?? urlCardKey) : null,
            fobCards: fobHippodromes,
            type: selectedBettingType,
        });
        if (brk === "ok") {
            shownBreakKey.current = null;
            return;
        }
        const key = `${brk}:${location.pathname}:${selectedBettingType?.id}`;
        if (shownBreakKey.current === key) {
            return;
        }
        shownBreakKey.current = key;

        if (brk === "card") {
            // Kart FOB listesinden düştü: kapsam "Hepsi"ye açılır. Tür ondan SONRA
            // seçilir - yeni kapsamda eski tür hâlâ oynanıyor olabilir.
            navigate(paths.fobBetting.url);
        } else {
            setPickedBettingType(nextFobTypeWithContent(
                hippodrome ? [hippodrome] : fobHippodromes,
                selectedBettingType
            ));
        }
        const notice = fobMoveNotice({brk, typeName: selectedBettingType?.name});
        if (notice) {
            // Projenin kendi modalı; müşterekteki kapanma uyarısıyla aynı bileşen.
            modalServiceSubject.next({
                title: "Bahisler kapandı",
                case: "warning",
                content: asModalHtml(notice),
                confirm: {cancel: {label: "Tamam"}},
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fobHippodromes, hippodrome?._id, selectedBettingType?.id, location.pathname]);


    useEffect(() => {
        setPickedBettingType(null);
    }, [hippodrome])

    useEffect(() => {
        if (!hippodrome) return;
        try {
            // @ts-ignore
            fbq("track", "ViewContent", {
                content_name: hippodrome.hippodrome,
                content_category: selectedBettingType?.name,
                content_ids: "",
                content_type: "product",
                value: selectedBettingType?.price,
                currency: "TRY",
                event_source_url: `${paths.fobBetting.url}/${(hippodrome.keyword + hippodrome._id).toLowerCase()}`,
            });
        } catch (e) {
            console.error(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hippodrome])

    const handleChangeHippodrome = (value: string) => {
        if (value !== "all") {
            navigate(`${paths.fobBetting.url}/${value.toLowerCase()}`);
        } else {
            navigate(`${paths.fobBetting.url}`);
        }
    }

    const toggleHiddenResults = (hippodromeId: string) => {
        setHiddenResultsByHippodrome((prev) => ({...prev, [hippodromeId]: !prev[hippodromeId]}));
    }

    return (
        <>
            <div className={"bettingtype-options p-3 mb-3"}>
                <div className={"row"}>
                    <div className={"col-6 col-lg-3"}>
                        <HippodromeSelector
                            currentHippodrome={hippodrome}
                            onChangeHippodrome={handleChangeHippodrome}
                        />
                    </div>

                    <div className={"col-6 col-lg-3"}>
                        <BettingTypeSelector
                            selectedBettingType={selectedBettingType}
                            onChangeBettingType={setPickedBettingType}
                        />
                    </div>

                    <div className={"col-12 col-lg-6 pt-2 pt-lg-4"}>
                        <div className={"row"}>
                            <div className="col-4">
                                <Link
                                    to={linkHippodrome ? `${paths.betting.url}/${linkHippodrome?.keyword.toLowerCase()}${linkHippodrome?._id}/muhtemeller` : ''}
                                    className={`btn btn-muhtemeller`}
                                    aria-disabled={true}
                                >
                                    MUHTEMELLER
                                </Link>
                            </div>


                            <div className="col-4">
                                <Link
                                    to={linkHippodrome ? `${paths.betting.url}/${linkHippodrome?.keyword.toLowerCase()}${linkHippodrome?._id}/agf` : ''}
                                    className={`btn btn-agf`}
                                >
                                    AGF
                                </Link>
                            </div>

                            <div className="col-4">
                                <Link
                                    className={`btn btn-agf`}
                                    style={{fontSize: "12px", lineHeight: "1.2"}}
                                    to={`${paths.betting.url}`}
                                >
                                    <img alt={"iconFather"} src={redHorse} className={"me-1"} height={30}/>
                                    MÜŞTEREK BÜLTEN
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!isBulletinLoaded && <FobBettingSkeleton/>}

            {isBulletinLoaded && fobHippodromes.length === 0 && (
                <div className={"col-12"} style={{minHeight: "50vh"}}>
                    <div className={"page-widget"}>
                        <div className="hint-text text-center p-3">
                            <p className={"fs-6 mb-0"}>Sabit İhtimalli bahis türünde açık hipodrom bulunmamaktadır.</p>
                        </div>
                    </div>
                </div>
            )}

            {fobHippodromes.length > 0 && !(isMobile && isMobileSlipOpen) && (
                <div className="live-races-container">
                    <div className="live-icon-container">
                        <img src={liveIcon} className="live-icon" alt="canli"/>
                        <span className="fob-badge">{liveRunsCount}</span>
                    </div>

                    <div>
                        {liveRunsCount > 0 && (
                            <>
                                <span className="text-warning fw-bold cursor-pointer"
                                      onClick={() => setLiveOnly((prev) => !prev)}>
                                    Canlı Bahis
                                </span>{" "}
                                yapılabilir {liveRunsCount} koşu var.{"  "}
                            </>
                        )}
                        <button
                            className="btn btn-sm btn-secondary fw-semibold fs-7 mb-1 mt-1 mx-2"
                            style={{color: "#1e3d98"}}
                            onClick={() => setLiveOnly((prev) => !prev)}
                        >
                            {liveOnly && <img src={goRightIcon} alt="git" width={16} className={`me-1 flip-icon`}/>}
                            {liveOnly ? "Tüm Koşular" : "Aktif Koşular"}
                            {!liveOnly && <img src={goRightIcon} alt="git" width={16} className={`ms-1`}/>}
                        </button>
                    </div>
                </div>
            )}

            {fobHippodromes.length > 0 && <div className={"row"}>
                {(isMobile ? !isMobileSlipOpen : true) && (
                    <div className={isMobile ? "col-12" : ""}>
                        <BettingTable
                            currentHippodrome={hippodrome}
                            selectedBettingType={selectedBettingType}
                            hiddenResultsByHippodrome={hiddenResultsByHippodrome}
                            onToggleHiddenResults={toggleHiddenResults}
                            liveOnly={liveOnly}
                        />
                    </div>
                )}

                {!isMobile && isDesktopSlipOpen && (
                    <Draggable handle=".betting-type" bounds="body">
                        <div className={"fob-betslip"}>
                            <NewFobBetslip
                                selectedBettingType={selectedBettingType}
                                onClose={() => setIsDesktopSlipOpen(false)}
                            />
                        </div>
                    </Draggable>
                )}

                {!isMobile && !isDesktopSlipOpen && (
                    <NewFobBetslipToggleTab onOpen={() => setIsDesktopSlipOpen(true)}/>
                )}

                {isMobile && selectedBettingType && !isMobileSlipOpen && (
                    <NewMobileFobBetslipBar onOpen={() => setIsMobileSlipOpen(true)}/>
                )}

                {isMobile && isMobileSlipOpen && (
                    <div className="col-betslip">
                        <NewFobBetslip
                            selectedBettingType={selectedBettingType}
                            onClose={() => setIsMobileSlipOpen(false)}
                        />
                    </div>
                )}
            </div>}
        </>
    )
}

function HippodromeSelector({currentHippodrome, onChangeHippodrome}: any) {
    const fobHippodromes = useAvailableFOBHippodromes();
    const handleChange = (e: any) => {
        onChangeHippodrome(e.target.value);
    }

    return (
        <div className={"col-12"}>
            <label className="hidden-sm">HİPODROMLAR</label>
            <select
                value={currentHippodrome ? currentHippodrome.keyword + currentHippodrome._id : "all"}
                onChange={handleChange}
            >
                <option value={"all"}>Hepsi</option>

                {fobHippodromes.map((_hippodrome: any, index: number) => {
                    if (_hippodrome.wager_details.length === 0) return null;

                    return (
                        <option key={`hippodrome-${index}`} value={_hippodrome.keyword + _hippodrome._id}>
                            {_hippodrome.hippodrome}
                            {new Date(_hippodrome.date).getDate() <= new Date().getDate() ? (
                                <>{_hippodrome.nextRun && ` - ${_hippodrome.nextRun.no}. Koşu ${_hippodrome.nextRun.time}`}</>
                            ) : (
                                <> - ({dateFormat(_hippodrome.date)})</>
                            )}
                        </option>
                    )
                })}
            </select>
        </div>
    )
}

function BettingTypeSelector({selectedBettingType, onChangeBettingType}: any) {
    const currentBettingTypes = bettingTypes.filter((bt: any) => (
        bt.isFob && bt.isSelectable
    ))

    const handleChange = (e: any) => {
        const bettingType = bettingTypes.find((bt: any) => bt.id === Number(e.target.value)) ?? null;
        onChangeBettingType(bettingType);
    }

    return (
        <div className={"col-12"}>
            <label className="hidden-sm">BAHİS TÜRÜ</label>
            <select value={selectedBettingType?.id ?? ""} onChange={handleChange}>
                {currentBettingTypes.map((_bettingType: any, index: number) => (
                    <option key={`betting-type-${index}`} value={_bettingType.id}>
                        {_bettingType.name}
                    </option>
                ))}
            </select>
        </div>
    )
}

function FobBettingSkeleton() {
    return (
        <div className={"col-12"} style={{minHeight: "50vh"}}>
            {[...Array(2)].map((_card, cardIndex) => (
                <div className={"fob-card"} key={`fob-skeleton-card-${cardIndex}`}>
                    <div className={"fob-header d-flex justify-content-between align-items-center"}>
                        <span className={"fob-skeleton-bar on-header"} style={{width: 170}}></span>
                        <span className={"fob-skeleton-bar on-header"} style={{width: 90}}></span>
                    </div>
                    <div className={"p-2"}>
                        {[...Array(2)].map((_run, runIndex) => (
                            <div className={"card run-card mb-2"} key={`fob-skeleton-run-${cardIndex}-${runIndex}`}>
                                <div className={"card-body"}>
                                    <div className={"row align-items-center p-2"}>
                                        <div className={"col-9 d-flex flex-column gap-2"}>
                                            <span className={"fob-skeleton-bar"} style={{width: "35%"}}></span>
                                            <span className={"fob-skeleton-bar sm"} style={{width: "60%"}}></span>
                                        </div>
                                        <div className={"col-3 d-flex justify-content-end"}>
                                            <span className={"fob-skeleton-bar pill"}></span>
                                        </div>
                                    </div>
                                    {[...Array(3)].map((_row, rowIndex) => (
                                        <div className={"fob-list-body"} key={`fob-skeleton-row-${cardIndex}-${runIndex}-${rowIndex}`}>
                                            <span className={"fob-skeleton-bar"} style={{width: "45%"}}></span>
                                            <span className={"fob-skeleton-bar odd"}></span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

function BettingTable({currentHippodrome, selectedBettingType, hiddenResultsByHippodrome, onToggleHiddenResults, liveOnly}: any) {
    const fobHippodromes = useAvailableFOBHippodromes();
    const hippodromesToShow = currentHippodrome
        ? fobHippodromes.filter((_h: any) => _h._id === currentHippodrome._id)
        : fobHippodromes;

    if (liveOnly) {
        const liveRuns = hippodromesToShow
            .flatMap((hippodrome: any) => hippodrome.runs
                .filter((run: any) => run.fob_wager_status && (
                    !selectedBettingType
                    || selectedBettingType.isHeadToHead
                    || (selectedBettingType.isFavoriteExcluded
                        ? runHasFavoriteExcludedMarket(run)
                        : isRunEligibleForFobBettingType(hippodrome, run, selectedBettingType.id))
                ))
                .map((run: any) => ({hippodrome, run})))
            .sort((a: any, b: any) => a.run.running_date - b.run.running_date);

        return (
            <div className={"col-12"}>
                {liveRuns.length === 0 && (
                    <p className="alert alert-warning fw-bold mb-0 m-3">
                        Şu anda canlı bahis yapılabilecek koşu bulunmamaktadır.
                    </p>
                )}
                {liveRuns.map(({hippodrome, run}: any, i: number) => (
                    <div className={"fob-card"} key={`fob-live-run-${hippodrome._id}-${run.no}-${i}`}>
                        <NewFobHeader
                            hippodrome={hippodrome}
                            bettingType={selectedBettingType}
                            hidden={hiddenResultsByHippodrome[hippodrome._id] ?? true}
                            onToggleHidden={() => onToggleHiddenResults(hippodrome._id)}
                        />
                        <div className={"p-2"}>
                            <NewFobBody
                                hippodrome={{...hippodrome, runs: [run]}}
                                index={i}
                                selectedBettingType={selectedBettingType}
                                hidden={hiddenResultsByHippodrome[hippodrome._id] ?? true}
                                isLive={liveOnly}
                            />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    const hippodromesWithContent = hippodromesToShow.filter(
        (hippodrome: any) => hippodromeHasFobContent(hippodrome, selectedBettingType)
    );

    return (
        <div className={"col-12"}>
            {hippodromesWithContent.length === 0 && (
                <p className="alert alert-warning fw-bold mb-0 m-3">
                    Seçili bahis tipinde açık hipodrom bulunmamaktadır.
                </p>
            )}
            {hippodromesWithContent.map((hippodrome: any, hippodromeIndex: number) => (
                <div className={"fob-card"} key={`hippodrome-${hippodrome._id}-${hippodromeIndex}`}>
                    <NewFobHeader
                        hippodrome={hippodrome}
                        bettingType={selectedBettingType}
                        hidden={hiddenResultsByHippodrome[hippodrome._id] ?? true}
                        onToggleHidden={() => onToggleHiddenResults(hippodrome._id)}
                    />
                    <div className={"p-2"}>
                        <NewFobBody
                            hippodrome={hippodrome}
                            index={hippodromeIndex}
                            selectedBettingType={selectedBettingType}
                            hidden={hiddenResultsByHippodrome[hippodrome._id] ?? true}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

function NewFobHeader({hippodrome, bettingType, hidden, onToggleHidden}: any) {
    return (
        <>
            {isMobile ? (
                <div className={"d-flex justify-content-between flex-column fob-header"}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className={"mb-0 fw-bold"}>{hippodrome.hippodrome}</h5>
                        </div>

                        <div className="fw-light " style={{fontSize: "11px"}}>
                            {bettingType?.name}
                        </div>
                    </div>
                    <div className={"d-flex justify-content-between align-items-center"}>
                        <div className="d-flex flex-column  hippodrome-conditions">
                            <div className="fw-light">Sıcaklık: {hippodrome.weather.temperature}°C</div>
                            <div className="fw-light">Nem: %{hippodrome.weather.humidity}</div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="fob-row">
                                <div className={"mx-1"}>
                                    <div>
                                        <Link
                                            to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}/yorumlar`}
                                            className="btn btn-secondary fw-semibold fs-6 "
                                        >
                                            YORUMLAR
                                        </Link>
                                    </div>
                                </div>
                                <div className="mx-1">
                                    <div className={`nowrap`}>
                                        <Link
                                            to={paths.stream.url}
                                            className="btn btn-secondary fw-semibold fs-6 fob-tv-button"
                                        >
                                            TV
                                        </Link>
                                    </div>
                                </div>
                                <div className="mx-1">
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-secondary fw-semibold fs-6 dropdown-toggle setting-dropdown"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-gear"
                                                viewBox="0 0 16 16"
                                            >
                                                <path
                                                    d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                                                <path
                                                    d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
                                            </svg>
                                        </button>
                                        <ul className="dropdown-menu bg-white w-100">
                                            <li className={"w-100"}>
                                                <a
                                                    className="dropdown-item text-start"
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        onToggleHidden();
                                                    }}
                                                >
                                                    {hidden ? "Sonuçları göster" : "Sonuçları gizle"}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-block mb-0 px-2 py-0 fw-bold ">
                                <div className="d-flex  justify-content-center align-items-center fs-5 next-run">
                                    <span className="fs-6">Sıradaki koşu</span>
                                    <div className={"d-flex justify-content-center align-items-center"}>
                                        <RaceCountdown hippodrome={hippodrome}></RaceCountdown>

                                        <span className="fs-6 ms-1">{"  sonra."}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={"d-flex justify-content-between align-items-center fob-header"}>
                    <div className="d-flex flex-column">
                        <h5 className={"mb-0 fw-bold"}>{hippodrome.hippodrome}</h5>

                        <div className="d-flex justify-content-between align-items-center hippodrome-conditions">
                            <div className="fw-light me-2">Sıcaklık: {hippodrome.weather.temperature}°C</div>
                            <div className="fw-light">Nem: %{hippodrome.weather.humidity}</div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="fob-row">
                            <div className={"mx-1"}>
                                <div>
                                    <Link
                                        to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}/yorumlar`}
                                        className="btn btn-secondary fw-semibold fs-6 "
                                    >
                                        YORUMLAR
                                    </Link>
                                </div>
                            </div>
                            <div className="mx-1">
                                <div className={`nowrap`}>
                                    <Link to={paths.stream.url}
                                          className="btn btn-secondary fw-semibold fs-6 ">
                                        TV
                                    </Link>
                                </div>
                            </div>
                            <div className="mx-1">
                                <div className="dropdown">
                                    <button
                                        className="btn btn-secondary fw-semibold fs-6 dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-gear"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                                            <path
                                                d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
                                        </svg>
                                    </button>
                                    <ul className="dropdown-menu bg-white w-100">
                                        <li className={"w-100"}>
                                            <a
                                                className="dropdown-item text-start"
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onToggleHidden();
                                                }}
                                            >
                                                {hidden ? "Sonuçları göster" : "Sonuçları gizle"}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-block mb-0 px-2 py-0 fw-bold ">
                            <div className="fw-light d-flex justify-content-between">
                                {bettingType?.name}
                            </div>

                            <div className="d-flex  justify-content-center align-items-center fs-5 next-run">
                                <span className="fs-6">Sıradaki koşu&nbsp;</span>
                                <div className={"d-flex justify-content-center align-items-center"}>
                                    <RaceCountdown hippodrome={hippodrome}></RaceCountdown>

                                    <span className="fs-6 ms-1">{"  sonra."}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

function renderOddsValue(entry: any, lockWidth: number = 20) {
    if (entry?.show === false || entry?.bettable === false) {
        return <img width={lockWidth} src={lockIcon}/>;
    }

    return entry?.win_odds && entry.win_odds > 1 ? (
        entry.win_odds
    ) : entry?.status === 'o' ? (
        'KO'
    ) : (
        <img width={lockWidth} src={lockIcon}/>
    );
}

function renderPickButtonContent(hasAnchor: boolean, entry: any) {
    if (!hasAnchor) {
        return <img width={20} src={plusIcon}/>;
    }
    return renderOddsValue(entry);
}

function PickCheckIcon() {
    return (
        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    );
}

function NewOddButton({run, horse, hippodrome, selectedBettingType}: any) {
    const oddKey = `${horse.no}${selectedBettingType.suffix ?? ''}`;
    const entry = fobOddsEntry(run, selectedBettingType.id, oddKey);
    const selection = {hippodrome, run, oddKey, horseNos: [String(horse.no)], bettingType: selectedBettingType.id};

    const isSelected = FOBBetslip.isAdded(selection) !== false;

    const handleClick = () => {
        const hasLiveOdds = entry?.show && entry?.win_odds && entry.win_odds > 1;
        if (hasLiveOdds || entry?.status === 'o') {
            FOBBetslip.toggle(selection);
        }
    };

    if (selectedBettingType.isFavoriteExcluded && fobExcludedHorseNo(run) === String(horse.no)) {
        return (
            <div className="odd-button" style={{cursor: "not-allowed", background: "#ECEDEA", color: "#5d6b6a", fontSize: 11, fontWeight: 600}}>
                Favori
            </div>
        );
    }

    // `key`: oran değişim vurgusunun animasyonu ancak düğüm yeniden kurulunca baştan başlıyor.
    // Sınıf ("up") art arda gelen aynı yönlü değişimlerde aynı kaldığı için tek başına yetmiyor.
    return (
        <div
            key={entry?.oddsRevision ?? 0}
            onClick={handleClick}
            className={`odd-button ${isSelected ? "selected" : ""} ${entry?.isUpdated ?? ""}`}
            style={{cursor: "pointer"}}>
            {renderOddsValue(entry, 18)}
        </div>
    );
}

function FobPairPickButtons({run, horse, hippodrome, selectedBettingType}: any) {
    const bettingTypeId = selectedBettingType.id;

    const pick = resolveFobCurrentPick(hippodrome, run, bettingTypeId);

    const horseNo = String(horse.no);
    const isFirst = pick.first === horseNo;
    const isSecond = pick.second === horseNo;

    const orderPair = (firstNo: any, secondNo: any): string[] => selectedBettingType.suffix
        ? [String(firstNo), String(secondNo)]
        : [String(Math.min(Number(firstNo), Number(secondNo))), String(Math.max(Number(firstNo), Number(secondNo)))];
    const buildOddsKey = (firstNo: any, secondNo: any) =>
        `${orderPair(firstNo, secondNo).join('-')}${selectedBettingType.suffix ?? ''}`;

    const handlePick = (position: 'first' | 'second') => {
        const isSelectedNow = pick[position] === horseNo;

        if (isSelectedNow) {
            const isComplete = pick.first !== null && pick.second !== null;
            if (isComplete) {
                FOBBetslip.remove({
                    hippodrome, run, bettingType: bettingTypeId,
                    oddKey: buildOddsKey(pick.first, pick.second),
                    horseNos: orderPair(pick.first, pick.second),
                });
                const otherPosition = position === 'first' ? 'second' : 'first';
                const otherNo = pick[otherPosition];
                FOBBetslip.setPendingPick({
                    hippodrome, run, bettingType: bettingTypeId,
                    first: otherPosition === 'first' ? otherNo : null,
                    second: otherPosition === 'second' ? otherNo : null,
                });
            } else {
                FOBBetslip.clearPendingPick(hippodrome, run, bettingTypeId);
            }
            return;
        }

        const otherPosition = position === 'first' ? 'second' : 'first';
        const otherNo = pick[otherPosition];

        if (otherNo !== null) {
            const firstNo = position === 'first' ? horseNo : otherNo;
            const secondNo = position === 'first' ? otherNo : horseNo;
            const nextKey = buildOddsKey(firstNo, secondNo);
            const entry = run.event_odds?.[nextKey];
            const hasLiveOdds = entry?.show && entry?.win_odds && Number(entry.win_odds) > 1;
            if (hasLiveOdds || entry?.status === 'o') {
                FOBBetslip.clearPendingPick(hippodrome, run, bettingTypeId);
                FOBBetslip.add({
                    hippodrome, run, bettingType: bettingTypeId,
                    oddKey: nextKey,
                    horseNos: orderPair(firstNo, secondNo),
                });
            }
        } else {
            FOBBetslip.setPendingPick({
                hippodrome, run, bettingType: bettingTypeId,
                first: position === 'first' ? horseNo : null,
                second: position === 'second' ? horseNo : null,
            });
        }
    };

    const firstDisplayEntry = pick.second !== null
        ? run.event_odds[buildOddsKey(horseNo, pick.second)]
        : null;

    const secondDisplayEntry = pick.first !== null
        ? run.event_odds[buildOddsKey(pick.first, horseNo)]
        : null;

    return (
        <div className={"d-flex gap-2"}>
            <div className={"fob-pick-wrap"}>
                <span className={"fob-pick-badge"}>1. AT</span>
                <div
                    onClick={() => !isSecond && handlePick('first')}
                    className={`odd-button ${isFirst ? "selected" : ""}`}
                    style={{cursor: isSecond ? "not-allowed" : "pointer", opacity: isSecond ? 0.4 : 1}}
                >
                    {isFirst ? <PickCheckIcon/> : renderPickButtonContent(pick.second !== null, firstDisplayEntry)}
                </div>
            </div>
            <div className={"fob-pick-wrap"}>
                <span className={"fob-pick-badge"}>2. AT</span>
                <div
                    onClick={() => !isFirst && handlePick('second')}
                    className={`odd-button ${isSecond ? "selected" : ""}`}
                    style={{cursor: isFirst ? "not-allowed" : "pointer", opacity: isFirst ? 0.4 : 1}}
                >
                    {isSecond ? <PickCheckIcon/> : renderPickButtonContent(pick.first !== null, secondDisplayEntry)}
                </div>
            </div>
        </div>
    );
}

function NewFobBody({hippodrome, index, selectedBettingType, hidden, isLive}: any) {
    useFobBetslip();
    useFobPendingPicks();

    if (!selectedBettingType) {
        return (
            <div className={"col-12 p-3"}>
                <p className="alert alert-warning fw-bold mb-0">Lütfen bir bahis türü seçin.</p>
            </div>
        );
    }

    const isH2H = selectedBettingType.isHeadToHead
    if (isH2H) {
        return (
            <H2HBody
                hippodrome={hippodrome}
                index={index}
                selectedBettingType={selectedBettingType}
                hidden={hidden}
                isLive={isLive}
            />
        )
    }

    return (
        <React.Fragment key={`dailyruns-i-${index}`}>
            <ResponsiveMasonry key={hippodrome._id} columnsCountBreakPoints={{
                350: 1,
                750: isLive ? 1 : 2,
                900: isLive ? 1 : 3
            }}>
                <Masonry key={hippodrome._id}>
                    {hippodrome.runs
                        .filter((run: any) => selectedBettingType.isFavoriteExcluded
                            ? runHasFavoriteExcludedMarket(run)
                            : isRunEligibleForFobBettingType(hippodrome, run, selectedBettingType.id))
                        .map((run: any, index: any) => (
                            <FobRunCard
                                key={"fob-run-card-" + run.no + hippodrome.keyword + index}
                                hippodrome={hippodrome}
                                run={run}
                                index={index}
                                selectedBettingType={selectedBettingType}
                                hidden={hidden}
                                todayResults={todayResults}
                            />
                        ))}
                </Masonry>
            </ResponsiveMasonry>
        </React.Fragment>
    );
}

function FobRunCard({hippodrome, run, index, selectedBettingType, hidden, todayResults}: any) {
    const [isOpen, setIsOpen] = useState<boolean>(!!run.fob_wager_status);
    const [openHorseNos, setOpenHorseNos] = useState<Set<any>>(() => new Set());
    const toggleHorseOpen = (no: any) => setOpenHorseNos((prev) => {
        const next = new Set(prev);
        if (next.has(no)) {
            next.delete(no);
        } else {
            next.add(no);
        }
        return next;
    });
    const [sortMode, setSortMode] = useState<'no' | 'agf' | 'odds' | 'start' | null>(null);
    const favoriteNo = selectedBettingType.isFavoriteExcluded ? fobExcludedHorseNo(run) : null;
    const horses = !sortMode ? run.horses
        : sortMode === 'no' ? _.orderBy(run.horses, [(a: any) => Number(a["no"])], ["asc"])
            : sortMode === 'agf' ? _.orderBy(run.horses, ["agf_ratio1"], ["desc"])
                : sortMode === 'odds' ? _.orderBy(run.horses, [(a: any) => Number(run.event_odds[Number(a.no)]?.win_odds)], ["asc"])
                    : _.orderBy(run.horses, ["start"], ["desc"]);

    if (todayResults[hippodrome.keyword] && todayResults[hippodrome.keyword].runsMap![run.no] && run.show_fob === false) {
        if (hidden !== true) {
            return (
                <div className="card run-card"
                     key={"fob-list-run" + run.no + hippodrome.keyword + index}>
                    <div className="card-body">
                        <div className={"d-flex justify-content-between align-items-center p-1"}>
                            <h5 className="card-title">{run.no}. Koşu</h5>
                            <div className="d-flex align-items-center">
                                <p
                                    style={{
                                        borderRadius: "10px",
                                        border: "1px solid",
                                        padding: "0.25rem",
                                        background: "rgb(239, 239, 244)",
                                        marginRight: "10px",
                                    }}
                                    className={"mb-0 fw-bold"}
                                >
                                    {run.time}
                                </p>
                            </div>
                        </div>

                        {todayResults[hippodrome.keyword].runsMap![run.no].horses.map((el: any, i: number) => {
                            if (i === 0 || i === 1 || i === 2) {
                                return (
                                    <div
                                        key={"fob-result-horse-" + el.no + hippodrome.keyword + i}
                                        className={"d-flex fob-list-body"}
                                    >
                                        <div className={""}>
                                            <span className={"fw-bold"}>{el.result} - </span>{" "}
                                            <span
                                                style={{
                                                    color: el.result == 1 ? "rgb(237 28 36)" : "",
                                                }}
                                            >
                                  {el.name}
                                </span>{" "}
                                            ({el.no})
                                        </div>
                                        <div>{el.difference}</div>
                                    </div>
                                );
                            }
                        })}
                    </div>
                </div>
            );
        }
        return null;
    } else {

        return (
            <div className="card run-card"
                 key={"fob-list-run" + run.no + hippodrome.keyword + index}>
                <div className="card-body">
                    <div className={"row align-items-center p-2"}>
                        <div
                            onClick={() => setIsOpen((o) => !o)}
                            className={`col-9 d-flex flex-column`}
                        >
                            <div className={"d-flex align-items-center"}>
                                <h5 className="card-title mb-0">{run.no}.Koşu</h5>

                                <span className="course mx-1"
                                      style={{backgroundColor: courseColors[run.course]}}>
                            {run.course}
                          </span>
                                <span className={"fw-medium"}>{run?.distance}m</span>
                            </div>
                            <div>
                                <p className="fw-medium mb-0"
                                   style={{fontSize: isMobile ? "14px" : "10px"}}>
                                    {run?.group} {run?.type_detail || ""} {run?.gender || ""} {run?.gender_detail || ""}
                                </p>
                            </div>
                        </div>

                        <div className={`col-3 d-flex justify-content-end gap-2`}>
                            {isOpen && (
                                <div className="dropdown dropdown-without-arrow">
                                    <button
                                        className={`btn btn-sm btn-outline-primary dropdown-toggle px-1 py-0`}
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="21"
                                            height="21"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>
                                        </svg>
                                    </button>
                                    <ul className="dropdown-menu bg-white">
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSortMode('no');
                                                }}
                                            >
                                                No'ya Göre
                                            </button>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item"
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSortMode('agf');
                                                }}
                                            >
                                                AGF'ye Göre
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item"
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSortMode('odds');
                                                }}
                                            >
                                                Oran'a Göre
                                            </a>
                                        </li>
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSortMode('start');
                                                }}
                                            >
                                                Kulvar'a Göre
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}

                            <div className={"d-flex flex-row"} onClick={() => setIsOpen((o) => !o)}>
                                <p className={"mb-0 fw-bold fs-6"}>
                                    {run.time}{" "}
                                </p>
                                {isOpen ? <img src={iconUpArrow}/> :
                                    <img src={iconDownArrow}/>}
                            </div>
                        </div>
                    </div>
                    {isOpen &&
                        <>

                            {horses.map((el: any, i: number) => {
                                return (
                                    <React.Fragment
                                        key={"fob-list-horse-frag-" + el.no + hippodrome.keyword + i}>
                                        <div
                                            style={favoriteNo === String(el.no) ? {opacity: 0.55, backgroundColor: '#F2F2F0'} : !el.run_status ? {opacity: 0.4} : {}}
                                            className={"d-flex fob-list-body"}
                                        >
                                            <div
                                                className={"d-flex justify-content-between align-items-center "}>
                                                <div
                                                    style={{
                                                        paddingRight: "5px",
                                                        marginRight: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => toggleHorseOpen(el.no)}
                                                    className={openHorseNos.has(el.no) ? "d-none" : ""}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="currentColor"
                                                        className="bi bi-caret-down"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659"/>
                                                    </svg>
                                                </div>
                                                <div
                                                    style={{
                                                        paddingRight: "5px",
                                                        marginRight: "5px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => toggleHorseOpen(el.no)}
                                                    className={!openHorseNos.has(el.no) ? "d-none" : ""}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="currentColor"
                                                        className="bi bi-caret-up"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659"/>
                                                    </svg>
                                                </div>

                                                <div className={"me-1"}>
                                                    <img
                                                        src={`https://medya-cdn.tjk.org/formaftp/${el.owner.code}.jpg`}
                                                        onError={({currentTarget}) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = jokeyIcon;
                                                        }}
                                                        width={21}
                                                        style={{borderRadius: "50%"}}
                                                        alt={el.jokey.short_name}
                                                        className="jockey-uniform float-start "
                                                    />
                                                </div>
                                                <div
                                                    className={"d-flex flex-column align-items-start"}>
                                                    <div>
                                                        {el.run_status ? (
                                                            <>{el.no} - </>
                                                        ) : (
                                                            <span
                                                                className="fw-bold text-danger opacity-100">
                                                                                        K{" - "}
                                                                                    </span>
                                                        )}
                                                        <span
                                                            className="fw-bold">{el.name}</span>
                                                        {favoriteNo === String(el.no) && <span style={{fontSize: 10, fontWeight: 700, padding: '1px 5px', borderRadius: 4, background: '#D4D6CE', color: '#3d4f4e', marginLeft: 6}}>FAVORİ</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={""}>
                                                <div className={"d-flex"}>
                                                    {BettingTypesMap[selectedBettingType.id]?.isFobPairPick ? (
                                                        <FobPairPickButtons
                                                            run={run}
                                                            horse={el}
                                                            hippodrome={hippodrome}
                                                            selectedBettingType={selectedBettingType}
                                                        />
                                                    ) : (
                                                        <NewOddButton
                                                            run={run}
                                                            horse={el}
                                                            hippodrome={hippodrome}
                                                            selectedBettingType={selectedBettingType}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {openHorseNos.has(el.no) && (
                                            <div className={"d-block"}>
                                                <div className={"d-flex"}>
                                                    <div className="w-50 px-1 horse-info-fob">
                                                        Son 6:{" "}
                                                        <span
                                                            dangerouslySetInnerHTML={{__html: getPrettyFormatLastSix(el.last6)}}></span>
                                                    </div>
                                                    <div
                                                        className="w-50 px-1 horse-info-fob d-flex justify-content-between">
                                                        {el.agf_ratio1 && el.agf_ratio1 !== 0 ? (
                                                            <div className={""}>
                                                                AGF1:{" "}
                                                                <span
                                                                    className={`fw-bold ${el.agf_sort_no1 === 1 ? "text-success" : ""}`}>
                                          %{el.agf_ratio1}
                                        </span>
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )}

                                                        {el.agf_ratio2 && el.agf_ratio2 !== 0 ? (
                                                            <div className={""}>
                                                                AGF2:{" "}
                                                                <span
                                                                    className={`fw-bold ${el.agf_sort_no2 === 1 ? "text-success" : ""}`}>
                                          %{el.agf_ratio2}
                                        </span>
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )}
                                                        {el.agf_ratio1 === 0 && el.agf_ratio2 === 0 && (
                                                            <div>
                                                                AGF: <span
                                                                className={"fw-bold"}>-</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className={"d-flex align-items-stretch"}>
                                                    <div className="w-50 px-1 horse-info-fob">
                                                        Jokey: <span
                                                        className="fw-bold ms-2">{el.jokey.short_name}</span>
                                                    </div>

                                                    <div className="w-50 px-1 horse-info-fob">
                                                        Antrenör: <span
                                                        className="fw-bold ms-2">{el.trainer.name}</span>
                                                    </div>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <div
                                                        className="w-50 px-1  fs-8 horse-info-fob">
                                                        Anne: <span
                                                        className="fw-bold ms-2">{el.mother}</span>
                                                        <br></br> Baba:{" "}
                                                        <span
                                                            className="fw-bold ms-2">{el.father}</span>{" "}
                                                    </div>
                                                    <div className="w-50 px-1 horse-info-fob">
                                                        En İyi Derece: <span
                                                        className="fw-bold ms-2">{el.best_time}</span>
                                                    </div>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <div className="w-50 px-1 horse-info-fob">
                                                        Start: <span
                                                        className="fw-bold ms-2">{el.start}</span>
                                                    </div>
                                                    <div className="w-50 px-1 horse-info-fob">
                                                        Kilo: <span
                                                        className="fw-bold ms-2">{el.weight}KG</span>
                                                    </div>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <div className="w-50 px-1 horse-info-fob">
                                                        KGS: <span
                                                        className="fw-bold ms-2">{el.kgs}</span>
                                                    </div>
                                                    <div
                                                        className="w-50 px-1 horse-info-fob d-flex align-items-center">
                                                        HP: <span
                                                        className="fw-bold ms-2">{el.handicap}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}

                            {!run.fob_wager_status &&
                                <div className={"d-flex fob-list-body"}>
                                    <div
                                        className={"d-flex justify-content-between align-items-center "}>
                                        <p className="my-1 alert alert-warning p-2 fs-7 fw-bold ">
                                            Kapanış Oranı Oyunu son sabit orana göre oynanır.
                                        </p>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        );
    }
}

function H2HBody({hippodrome, index, selectedBettingType, hidden, isLive}: any) {
    return (
        <React.Fragment key={`dailyruns-h2h-${index}`}>
            <ResponsiveMasonry key={hippodrome._id} columnsCountBreakPoints={{
                350: 1,
                750: isLive ? 1 : 2,
                900: isLive ? 1 : 2
            }}>
                <Masonry key={hippodrome._id}>
                    {hippodrome.runs.map((run: any, runIndex: any) => (
                        <FobH2HRunCard
                            key={"fob-h2h-run-card-" + run.no + hippodrome.keyword + runIndex}
                            hippodrome={hippodrome}
                            run={run}
                            runIndex={runIndex}
                            selectedBettingType={selectedBettingType}
                            hidden={hidden}
                            todayResults={todayResults}
                        />
                    ))}
                </Masonry>
            </ResponsiveMasonry>
        </React.Fragment>
    );
}

function FobH2HRunCard({hippodrome, run, runIndex, selectedBettingType, hidden, todayResults}: any) {
    const [isOpen, setIsOpen] = useState<boolean>(!!run.fob_h2h_status);

    if (todayResults[hippodrome.keyword] && todayResults[hippodrome.keyword].runsMap![run.no] && run.show_fob === false) {
        if (hidden !== true) {
            return (
                <div className="card run-card" key={"h2h-list-run" + run.no + hippodrome.keyword + runIndex}>
                    <div className="card-body">
                        <div className={"d-flex justify-content-between align-items-center p-1"}>
                            <h5 className="card-title">{run.no}. Koşu</h5>
                            <div className="d-flex align-items-center">
                                <p
                                    style={{
                                        borderRadius: "10px",
                                        border: "1px solid",
                                        padding: "0.25rem",
                                        background: "rgb(239, 239, 244)",
                                        marginRight: "10px",
                                    }}
                                    className={"mb-0 fw-bold"}
                                >
                                    {run.time}
                                </p>
                            </div>
                        </div>

                        {todayResults[hippodrome.keyword].runsMap![run.no].horses.map((el: any, i: number) => {
                            if (i === 0 || i === 1 || i === 2) {
                                return (
                                    <div
                                        key={"h2h-result-horse-" + el.no + hippodrome.keyword + i}
                                        className={"d-flex fob-list-body"}
                                    >
                                        <div className={""}>
                                            <span className={"fw-bold"}>{el.result} - </span>{" "}
                                            <span
                                                style={{
                                                    color: el.result == 1 ? "rgb(237 28 36)" : "",
                                                }}
                                            >
                                  {el.name}
                                </span>{" "}
                                            ({el.no})
                                        </div>
                                        <div>{el.difference}</div>
                                    </div>
                                );
                            }
                        })}
                    </div>
                </div>
            );
        }

        return <></>;
    }

    const hasH2HMarket = !!(run.fob_h2h_status && run.fob_h2h && Object.keys(run.fob_h2h).length > 0);

    return (
        <div className="card run-card"
             key={"h2h-list-run" + run.no + hippodrome.keyword + runIndex}>
            <div className="card-body">
                <div className={"row align-items-center p-2"}>
                    <div
                        onClick={hasH2HMarket ? () => setIsOpen((o) => !o) : undefined}
                        className={`col-9 d-flex flex-column`}
                    >
                        <div className={"d-flex align-items-center"}>
                            <h5 className="card-title mb-0">{run.no}.Koşu</h5>

                            <span className="course mx-1" style={{backgroundColor: courseColors[run.course]}}>
                                                    {run.course}
                                                </span>
                            <span className={"fw-medium"}>{run?.distance}m</span>
                        </div>
                        <div>
                            <p className="fw-medium mb-0"
                               style={{fontSize: isMobile ? "14px" : "10px"}}>
                                {run?.group} {run?.type_detail || ""} {run?.gender || ""} {run?.gender_detail || ""}
                            </p>
                        </div>
                    </div>

                    <div className={`col-3 d-flex justify-content-end gap-2`}>
                        <div className={"d-flex flex-row"} onClick={hasH2HMarket ? () => setIsOpen((o) => !o) : undefined}>
                            <p className={"mb-0 fw-bold fs-6"}>
                                {run.time}{" "}
                            </p>
                            {hasH2HMarket && (isOpen ? <img src={iconUpArrow}/> : <img src={iconDownArrow}/>)}
                        </div>
                    </div>
                </div>
                {isOpen && hasH2HMarket &&
                    <>
                        {Object.entries(run.fob_h2h).map(([groupKey, pair]: [string, any]) => (
                            <div className={"h2h-match-card"}
                                 key={"h2h-match-" + groupKey + hippodrome.keyword + run.no}>
                                <div className={"h2h-match-label"}>Eşleşme</div>
                                <div className={"h2h-pair d-flex gap-2"}>
                                    <H2HSideButton
                                        run={run}
                                        hippodrome={hippodrome}
                                        selectedBettingType={selectedBettingType}
                                        entry={pair[0]}
                                        pair={pair}
                                    />
                                    <span className={"h2h-vs"}>VS</span>
                                    <H2HSideButton
                                        run={run}
                                        hippodrome={hippodrome}
                                        selectedBettingType={selectedBettingType}
                                        entry={pair[1]}
                                        pair={pair}
                                    />
                                </div>
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    );
}

function H2HSideButton({run, hippodrome, selectedBettingType, entry, pair}: any) {
    if (!entry) {
        return null;
    }
    const horse = run.horseMap?.[String(entry.horse_no)];
    const opponent = pair.find((p: any) => p !== entry);
    const horseNos = [String(entry.horse_no), String(opponent?.horse_no)];
    const selection = {
        hippodrome, run, bettingType: selectedBettingType.id,
        oddKey: horseNos.join('-'),
        horseNos,
    };

    const isSelected = FOBBetslip.isAdded(selection) !== false;

    const isSelectable = isOddsEntrySelectable(entry);

    const handleClick = () => {
        if (isSelectable) {
            FOBBetslip.toggle(selection);
        }
    };

    return (
        <div
            onClick={handleClick}
            className={`h2h-side ${isSelected ? "selected" : ""}`}
            style={{cursor: isSelectable ? "pointer" : "default"}}>
            {/* Forma görseli bültendeki kaynağın aynısı (sahibin kodu); yüklenemezse
                bültendeki gibi genel jokey ikonuna düşüyor. */}
            <img
                className={"h2h-silk"}
                src={`https://medya-cdn.tjk.org/formaftp/${horse?.owner?.code}.jpg`}
                onError={({currentTarget}) => {
                    currentTarget.onerror = null;
                    currentTarget.src = jokeyIcon;
                }}
                width={22}
                height={22}
                alt={horse?.jokey?.short_name ?? ""}/>
            <div className={"h2h-badge"}>{entry.horse_no}</div>
            <div className={"h2h-name"}>
                <div className={"fw-bold text-truncate"}>{horse?.name ?? ""}</div>
                <div className={"h2h-jockey text-truncate"}>{horse?.jokey?.short_name ?? ""}</div>
            </div>
            {/* `key`: vurgu sınıfı ("up") art arda gelen aynı yönlü değişimlerde aynı kaldığı
                için animasyon tek başına yeniden başlamıyor; `oddsRevision` her gerçek
                değişimde artıyor ve düğüm yeniden kurulunca animasyon baştan çalışıyor. */}
            <div className={"fw-bold"}>
                <span key={entry?.oddsRevision ?? 0} className={`odds-flash ${entry?.isUpdated ?? ""}`}>
                    {renderOddsValue(entry, 18)}
                </span>
            </div>
        </div>
    );
}
